/** @jsxImportSource @emotion/react */
import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalBtnGroup, SubTitleGroup, SubTitleLayout } from 'components/layouts/ContentLayout';
import { useLoading } from 'components/process/Loading';
import { useMessageBar } from 'hooks/useMessageBar';
import { Button } from '@mui/material';
import { IconButton } from 'components/buttons/IconSVG';
import _ from 'lodash';
import { useCommonModal } from 'hooks/useCommonModal';
import CustomGrid from 'components/grids/CustomGrid';
import PropTypes from 'prop-types';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { tabs } from 'components/layouts/Tab';
import { TabMenu } from 'models/md/MdIves';
import { DefaultProps } from 'pages/md/invest/MdIvesCmpuRegPage';
import LineInqPopup from '../../../popup/LineInqPopup';
import { MdLine } from 'models/md/MdLine';

const LineEqpNbuIspt = ({ elmPrjId }: DefaultProps) => {
  const { t } = useTranslation();
  const { isLoading } = useLoading();
  const { openMessageBar } = useMessageBar();
  const { openCommonModal } = useCommonModal();

  const [rowData, setRowData] = useState<MdLine[]>([]);
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);
  const [isOpenAddPopup, setIsOpenAddPopup] = useState<boolean>(false);

  const layoutDefinition = useMemo(() => {
    return [
      {
        binding: 'bildPlntCd',
        header: String(t('com.label.플랜트', '플랜트')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
      {
        binding: 'bldoNm',
        header: String(t('com.label.동 명', '동 명')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
      {
        binding: 'prdnProcCdNm',
        header: String(t('com.label.생산호기', '생산호기')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
      {
        header: String(t('com.label.믹서', '믹서')),
        columns: [
          {
            binding: 'boxStatNm',
            header: String(t('com.label.양극', '양극')),
            width: '*',
            align: 'center',
          },
          {
            binding: 'boxUnloDtm',
            header: String(t('com.label.음극', '음극')),
            width: '*',
            align: 'center',
          },
        ],
      },
      {
        header: String(t('com.label.포터', '포터')),
        columns: [
          {
            binding: 'boxStatNm',
            header: String(t('com.label.양극', '양극')),
            width: '*',
            align: 'center',
          },
          {
            binding: 'boxUnloDtm',
            header: String(t('com.label.음극', '음극')),
            width: '*',
            align: 'center',
          },
        ],
      },
      {
        header: String(t('com.label.롤프레스', '롤프레스')),
        columns: [
          {
            binding: 'boxStatNm',
            header: String(t('com.label.양극', '양극')),
            width: '*',
            align: 'center',
          },
          {
            binding: 'boxUnloDtm',
            header: String(t('com.label.음극', '음극')),
            width: '*',
            align: 'center',
          },
        ],
      },
      {
        header: String(t('com.label.슬리터', '슬리터')),
        columns: [
          {
            binding: 'boxStatNm',
            header: String(t('com.label.양극', '양극')),
            width: '*',
            align: 'center',
          },
          {
            binding: 'boxUnloDtm',
            header: String(t('com.label.음극', '음극')),
            width: '*',
            align: 'center',
          },
        ],
      },
    ];
  }, []);
  const tabMenus = useMemo<TabMenu[]>(() => {
    return [
      { id: 'E', name: '전극' },
      { id: 'A', name: '조립' },
    ];
  }, []);

  const initCodes = () => {
    //
  };

  const btnAdd = () => {
    setIsOpenAddPopup(true);
  };

  const btnDel = () => {
    //
  };

  const btnReset = () => {
    //
  };

  const btnSave = () => {
    //
  };

  useEffect(() => {
    initCodes();
  }, []);

  return (
    <>
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('setup.label.라인/설비대수 점검', '라인/설비대수 점검')}</h3>
        </SubTitleGroup>
      </SubTitleLayout>
      <div css={tabs.wrap} className="mt-6">
        <Tabs
          value={currentTabIndex}
          onChange={(e, newValue) => setCurrentTabIndex(newValue)}
          css={tabs.tab}
        >
          {tabMenus.map((o, idx) => (
            <Tab
              key={o.id}
              label={o.name}
              id={`td-ives-cmpu-tab-${idx}`}
              aria-controls={`td-ives-cmpu-tabpanel-${idx}`}
            />
          ))}
        </Tabs>
        <div css={tabs.btn}>
          <Button css={IconButton.button} className="icoNone ok" onClick={btnAdd}>
            {t('com.label.라인 추가', '라인 추가')}
          </Button>
          <Button css={IconButton.button} className="delRow" onClick={btnDel}>
            {t('com.label.행삭제', '행삭제')}
          </Button>
          <Button css={IconButton.button} className="icoNone" onClick={btnReset}>
            {t('com.label.초기화', '초기화')}
          </Button>
          <Button css={IconButton.button} className="save" disabled={isLoading} onClick={btnSave}>
            {t('com.label.저장', '저장')}
          </Button>
        </div>
      </div>
      <TabPanel value={currentTabIndex} index={0}>
        <CustomGrid
          id={`line-eqp-nbu-ispt-grid0`}
          layoutDefinition={layoutDefinition}
          rowData={rowData}
        />
      </TabPanel>
      <TabPanel value={currentTabIndex} index={1}>
        <CustomGrid
          id={`line-eqp-nbu-ispt-grid1`}
          layoutDefinition={layoutDefinition}
          rowData={rowData}
        />
      </TabPanel>
      {isOpenAddPopup && (
        <LineInqPopup open={isOpenAddPopup} close={() => setIsOpenAddPopup(false)} />
      )}
    </>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`setup-schedule-tabpanel-${index}`}>
      <div>{children}</div>
    </div>
  );
}

export default LineEqpNbuIspt;
